export default "https://d3fbpisbzpk8wt.cloudfront.net/202681805347/receiptScanNgCut-bundle-a85e696a3a2d9740b1dd135775bd925c.png";